import {
	apiConstants,
	config,
	downloadBlob,
	mockResolveApiCall,
	requestOptions,
	requestTypes,
} from "../../Utilities/Api";


//************************************************** STANDARD API SERVER CALLS ****************************************

const REPORT_EXPORT_ENDPOINTS: Record<string, string> = {
	patrons: "reports/patrons/export",
	orders: "own/reports/loan/export",
	"loan-library": "loan-library/reports/loan-history/export",
	"orders-completed": "own/reports/loan-history/export",
};

class ServerReportApi {
	static exportReport(reportSearchCriteria: Record<string, unknown>) {
		const {reportType, startDate, endDate, districtId} = reportSearchCriteria;
		const endpoint = REPORT_EXPORT_ENDPOINTS[reportType as string] ?? `reports/${reportType}/export`;
		return downloadBlob(
			requestOptions(`${config.URL}${endpoint}?startDate=${startDate}&endDate=${endDate}&districtId=${districtId}`,
				requestTypes.GET,
				null,
				apiConstants.successMessage.report.REPORT_DOWNLOADED));
	}

}

//************************************************** MOCK API SERVER CALLS ****************************************

class MockReportApi {
	static exportReport() {
		return mockResolveApiCall(true, apiConstants.successMessage.report.REPORT_DOWNLOADED);
	}

}

export const reportApi = config.environment.MODE === config.modes.SERVER ? ServerReportApi : MockReportApi;
